import {
  useSidebar,
  clampSidebarWidth,
  applySidebarWidthVar,
  SIDEBAR_DEFAULT_WIDTH,
} from "@/stores/sidebar";

export default function SidebarResizeHandle() {
  const { desktopCollapsed, setWidth } = useSidebar();
  if (desktopCollapsed) return null;

  function startResize(e: React.PointerEvent) {
    if (e.button !== 0) return;
    e.preventDefault();
    document.body.classList.add("sidebar-resizing");

    const move = (ev: PointerEvent) => {
      applySidebarWidthVar(clampSidebarWidth(ev.clientX));
    };
    const up = (ev: PointerEvent) => {
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", up);
      document.body.classList.remove("sidebar-resizing");
      setWidth(clampSidebarWidth(ev.clientX));
    };

    document.addEventListener("pointermove", move);
    document.addEventListener("pointerup", up);
  }

  return (
    <div
      className="sidebar-resize-handle"
      onPointerDown={startResize}
      onDoubleClick={() => setWidth(SIDEBAR_DEFAULT_WIDTH)}
      role="separator"
      aria-orientation="vertical"
      aria-label="Изменить ширину панели"
      title="Потяни, чтобы изменить ширину · двойной клик — сбросить"
    />
  );
}
